app.service('seeAlso', function(_, front, pageConfig, log, logData) {
	let $self;
	let offsetTop;

	let state = {
		isLoading: false,
		isLoaded: false,
		isViewed: false
	};

	function logEvent(params) {
		const { plu } = pageConfig.getData('productCard');
		const currentUrl = window.location.href;
		const currentPage = front.page();

		const defaults = {
			f03: plu,
			f06: currentUrl,
			f07: currentPage
		};

		const event = $.extend(defaults, params);

		log.event(event);
	}

	function logProductClick() {
		const index = parseInt($(this).index());
		const productPlu = $(this).data('plu');

		logEvent({
			id: 'Rek_klik',
			f04: productPlu,
			f05: index
		});
	}

	function logCarouselView() {
		const productsPlu = $self
			.find('li')
			.map((i, el) => el.dataset.plu)
			.get()
			.join(';');

		logEvent({
			id: 'Rek_view',
			f04: 1,
			f05: productsPlu
		});
	}

	function handleScroll(scrollY, windowHeight) {
		if (!state.isViewed && state.isLoaded) {
			if (windowHeight + scrollY > offsetTop) {
				state.isViewed = true;
				logCarouselView();
			}
		}

		if (state.isLoading) {
			return;
		}

		if (!state.isLoaded && scrollY > 600) {
			loadCarousel();
		}
	}

	function setEvents() {
		$self.on('click', '.js-UA-product', logProductClick);

		const windowHeight = $(window).height();

		_.onScroll(scrollY => handleScroll(scrollY, windowHeight));
	}

	function loadCarousel() {
		state.isLoading = true;

		const id = pageConfig.getData('productCard').id;
		const plu = pageConfig.getData('productCard').plu;
		const data = {
			productId: id,
			destination: 'PRODUCT_CARD',
			source: 'RECOMMENDATIONS'
		};
		let url = '/see-also-carousel.ltr';
		if (logData.showRecommendationsFromGoogleOnProductCard()){
			url = '/google-user-personalized-see-also-carousel.ltr';
			data.productPlu = plu;
			data.userId = logData.customerId();
		} else if (logData.showRecommendationsFromAWSonProductCard()) {
			url = '/user-personalized-see-also-carousel.ltr';
			data.userId = logData.customerId();
		};

		if (id) {
			$.ajax({
				url: url,
				data: data,
				success: function(html) {
					state.isLoading = false;
					loadSuccess(html);
				}
			});
		}
	}

	function loadSuccess(html) {
		if ($.trim(html) !== '') {
			state.isLoaded = true;

			$self
				.removeClass('loading')
				.addClass('showed')
				.find('ul')
				.append(html);

			offsetTop = $self.offset().top;
		} else {
			$self.remove();
		}
	}

	function init() {
		$self = $('#see-also');
		if(pageConfig.getData('productCard').recommendationsEnabled) {
			setEvents();
		}
	}

	return {
		init
	};
});
